module.exports = __webpack_public_path__ + "static/img/indexvideo.094a5dbb.jpg";